import { render } from "./CardNineteen.vue?vue&type=template&id=8f6053c4"
import script from "./CardNineteen.vue?vue&type=script&lang=js"
export * from "./CardNineteen.vue?vue&type=script&lang=js"

import "./CardNineteen.vue?vue&type=style&index=0&id=8f6053c4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__